import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import { FaClock, FaBook, FaChartLine } from "react-icons/fa";
import { TbCoinRupee } from "react-icons/tb";

function Dashboard({setActiveTab}) {
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("user_id");
  const [dashboard, setDashboard] = useState({});

  useEffect(() => {
    Dashbardlist();
  }, []);

  const formatDateTime = (dateTimeString) => {
    try {
      return new Date(dateTimeString).toLocaleString();
    } catch (error) {
      return "Invalid date";
    }
  };

  const Dashbardlist = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/dashboard-list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id: user_id }),
        }
      );

      if (!res.ok) throw new Error("Failed to fetch dashboard");

      const data = await res.json();
      setDashboard(data.dashboard);
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };
  const handleCourseTab = () => {
    setActiveTab("course");
  };
  return (
    <div className="dashboard_profle">
      <Card className="shadow border-0">
        <Card.Header className="bg-primary text-white fw-bold">
          <h5>Welcome to your dashboard!</h5>
        </Card.Header>
        <section className="py-4 bg-light dashboard_box">
          <Container>
            {/* Stat Cards */}
            <Row className="g-4 mb-4">
              <Col md={4} lg={4}>
                <Card
                  onClick={handleCourseTab}
                  className="box text-center shadow border-0 h-100"
                >
                  <Card.Body>
                    <FaBook size={32} className="mb-2" />
                    <Link className="d-block" onClick={() => setActiveTab("course")}>
                      <h6 className="fw-bold text-muted">Enrolled Courses</h6>
                      <h4 className="fw-semibold">
                        {dashboard.total_courses || 0}
                      </h4>
                    </Link>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={4} lg={4}>
                <Card className="box text-center shadow border-0 h-100">
                  <Card.Body>
                    <FaChartLine size={32} className="text-success mb-2" />
                    <Link
                      onClick={() => setActiveTab("course")}
                      className="d-block"
                    >
                      <h6 className="fw-bold text-muted">Purchased Packages</h6>
                      <h4 className="fw-semibold">
                        {dashboard.total_packages || 0}
                      </h4>
                    </Link>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={4} lg={4}>
                <Card className="box text-center shadow border-0 h-100">
                  <Card.Body>
                    <TbCoinRupee size={32} className="text-warning mb-2" />
                    <h6 className="fw-bold text-muted">Referral Coin</h6>
                    <p className="fw-bold mb-0 text-dark">
                      {dashboard.wallet_balance || 0}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* Upcoming Live Classes */}
            <Row className="mt-4">
              <Col>
                <Card className="shadow border-0">
                  <Card.Header className="fw-bold bg_light">
                    Upcoming Live Classes
                  </Card.Header>
                  <ListGroup variant="flush">
                    {dashboard.upcoming_classes &&
                    dashboard.upcoming_classes.length > 0 ? (
                      dashboard.upcoming_classes.map((cls) => (
                        <ListGroup.Item
                          key={cls.id}
                          className="d-flex justify-content-between"
                        >
                          <span>📚 {cls.title}</span>
                          <span className="text-muted">
                            <FaClock className="me-1" />
                            {formatDateTime(cls.start_time)}
                          </span>
                        </ListGroup.Item>
                      ))
                    ) : (
                      <ListGroup.Item className="text-muted">
                        No upcoming classes
                      </ListGroup.Item>
                    )}
                  </ListGroup>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </Card>
    </div>
  );
}

export default Dashboard;
